import { BodyText } from '@bamboohr/fabric';

export interface ProjectNameInfoMessageProps{
    children: string;
}

export function ProjectNameInfoMessage({ children }: ProjectNameInfoMessageProps){
    return <BodyText color="info">{children}</BodyText>;
}
